import React, { useState } from 'react';
import OverNLBADetailLayout from '../components/OverNLBADetailLayout';
import { contentAPI } from '../services/api';
import banner from '../assets/bg-post-hbo-financial-controller.jpg';
import './OverNLBA.css';

const OverNLBAOrganogram = () => {
  const [showOrganogram, setShowOrganogram] = useState(true);

  return (
    <OverNLBADetailLayout
      title="Organogram"
      subtitle="Een heldere organisatiestructuur voor kwalitatief en persoonlijk onderwijs."
      heroImage={banner}
      heroAlt="Organogram NLBA"
    >
            <h2>Organogram</h2>
            <p>
              NLBA Suriname werkt met een compacte organisatiestructuur waarin
              directie, opleidingsmanagement en docententeams nauw samenwerken.
            </p>
            <ul className="over-nlba-list">
              <li><strong>Directie:</strong> strategische koers, kwaliteit en partnerships.</li>
              <li><strong>Opleidingsmanagement:</strong> curriculum, planning en studentbegeleiding.</li>
              <li><strong>Docententeam:</strong> onderwijsuitvoering, toetsing en coaching.</li>
              <li><strong>Ondersteuning:</strong> administratie, communicatie en digitale leeromgeving.</li>
            </ul>

            {showOrganogram && (
              <div className="over-nlba-organogram-media">
                <img
                  src={contentAPI.organogramImageUrl()}
                  alt="Organogram NLBA Suriname"
                  className="over-nlba-organogram-image"
                  loading="lazy"
                  onError={() => setShowOrganogram(false)}
                />
              </div>
            )}

            {!showOrganogram && (
              <p className="over-nlba-muted">
                De organogram-afbeelding is momenteel niet beschikbaar.
              </p>
            )}

    </OverNLBADetailLayout>
  );
};

export default OverNLBAOrganogram;
